/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Age_WeeksInputs */

const en_age_weeks = /** @type {(inputs: Age_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}w`)
};

const de_age_weeks = /** @type {(inputs: Age_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} Wo`)
};

/**
* | output |
* | --- |
* | "{n}w" |
*
* @param {Age_WeeksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const age_weeks = /** @type {((inputs: Age_WeeksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Age_WeeksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_age_weeks(inputs)
	return en_age_weeks(inputs)
});